import moment from 'moment-timezone'
import { Text } from '../../styles/Components'
import { gsColors } from '../../styles/Variables'
import React, { useState } from 'react'
import { useField, useFormState } from 'react-final-form'
import CalendarDropdown from '../CalendarDropdown'

const CalendarField = React.forwardRef(
  ({ name, placeholder, isRange = false, format = true, disabled = false }, ref) => {
    const field = useField(name)
    const { submitFailed } = useFormState({ subscription: { submitFailed: true } })
    const { input } = field
    const [calendarOpen, setCalendarOpen] = useState(false)

    const toggleCalendar = () => setCalendarOpen((s) => !s)

    const error = submitFailed && !!field?.meta?.error

    return (
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
        <CalendarDropdown
          disabled={disabled}
          date={
            Array.isArray(input?.value)
              ? [
                moment(input.value[0]).toDate(),
                moment(input.value[1]).toDate(),
              ]
              : input?.value
                ? moment(input.value).toDate()
                : null
          }
          placeholder={placeholder}
          onClick={(date) => {
            input.onChange(date)
            toggleCalendar()
          }}
          open={calendarOpen}
          toggle={toggleCalendar}
          format={format}
          arrowBlack={true}
          ref={ref}
          error={error}
          isRange={isRange}
        />
        {!!error && (
          <Text color={gsColors.errorRed} margin="6px 0 0 0">
            {field?.meta?.error || 'Required'}
          </Text>
        )}
      </div>
    )
  },
)

export default CalendarField
